import { type ButtonProps } from '@poseidon/components/Button';

export const ButtonPropsSize = ['sm', 'xs', 'md'] as const;

export const hashCode = (str: string, mod: number): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash) % mod;
};

export const getBgColor = (
  s: string,
  colors: string[] = [
    'linear-gradient(45deg, #42a11f, #2dca1f)',
    'linear-gradient(45deg, #73173f, #ca1f68)',
    'linear-gradient(45deg, #99aa38, #3e761a)',
    'linear-gradient(45deg, #25145e, #3910bc)',
    'linear-gradient(45deg, #621e76, #9f1fca)',
    'linear-gradient(45deg, #a92e2e, #ec2727)',
  ],
) => {
  const colorIndex = s != null && typeof s === 'string' ? hashCode(s, colors.length) : undefined;
  return colors[colorIndex ?? 0];
};

export const isNotEmpty = (s: string | null | undefined): s is string => s != null && s.length > 0;

export const extractSizeFromClassName = (className?: string) => {
  const value = parseFloat(className?.match(/size-(\d+)/)?.[1] || '');
  return isNaN(value) ? undefined : Math.round(value * 4);
};

export function buttonMinHeight(size?: ButtonProps['size']) {
  return {
    'min-h-11': size == 'md',
    'min-h-9': size == null,
    'min-h-7': size === 'sm',
    'min-h-5': size === 'xs',
  };
}
export function buttonHeight(size?: ButtonProps['size']) {
  return {
    'h-11': size == 'md',
    'h-9': size == null,
    'h-7': size === 'sm',
    'h-5': size === 'xs',
  };
}

export function buttonHeightAndBorder(size?: ButtonProps['size']) {
  return {
    ...buttonHeight(size),
    ...buttonTextAndBorder(size),
  };
}

export function buttonRounded(size?: ButtonProps['size']) {
  return {
    'rounded-lg': size == 'md' || size == null,
    'rounded-md': size === 'sm',
    rounded: size === 'xs',
  };
}

export function buttonText(size?: ButtonProps['size']) {
  return {
    'text-md': size == 'md',
    'text-base': size == null,
    'text-xs': size === 'sm',
    'text-2xs': size === 'xs',
  };
}

export function buttonTextAndBorder(size?: ButtonProps['size']) {
  return {
    ...buttonText(size),
    ...buttonRounded(size),
    ...buttonMinHeight(size),
  };
}

export function buttonHPadding(size?: ButtonProps['size']) {
  return {
    'first:pl-3.5 last:pr-3.5': size == 'md',
    'first:pl-3 last:pr-3': size == null,
    'first:pl-2 last:pr-2': size == 'sm',
    'first:pl-1.5 last:pr-1.5': size == 'xs',
  };
}
